!(function () {
    angular.module('app.core')
        .config(['$httpProvider', function ($httpProvider) {
            // 预览模式拦截器
            $httpProvider.interceptors.push('previewModeHttpInterceptor');
        }]);
})();